module.exports = __webpack_public_path__ + "static/media/IconTemplates_-37.cf01eafc.svg";